import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { QuickOrderMain } from "../QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { useGuestClickGuard } from "../../Context/hook/useGuestClickGuard";
import { useAuth } from "../../Context/AuthContext";

export const QuickMenu = () => {
  const handleGuestClick = useGuestClickGuard();
  const { isAuthenticated } = useAuth();
  const isGuest = isAuthenticated === false;

  return (
    <>
      <section className="quick-links-sections d-none d-lg-block" onClickCapture={handleGuestClick}>
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="quick-link-list d-flex align-items-center justify-content-between">
                <div className="quick-links">
                  <ul className="m-0 p-0 quick-menu quick-menu-effect">
                    <li>
                      <a
                        type="btn"
                        data-bs-toggle={isGuest ? undefined : "offcanvas"}
                        data-bs-target={isGuest ? undefined : "#quickOrder-popup"}
                        aria-controls={isGuest ? undefined : "offcanvasRight"}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#f4e9eb",
                          display: "flex",
                          alignItems: "center",
                          justifySelf: "center",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <span className="wes-shopping-bag"></span>
                        Quick Order
                      </a>
                      {/*<a href="#">*/}
                      {/*  <span className="wes-quick-order" /> Quick Order*/}
                      {/*</a>*/}
                    </li>
                    <li>
                      <Link to={PAGES.BRAND}>
                        <span className="wes-shop-brand" /> Shop by Brands
                      </Link>
                    </li>
                    <li>
                      <Link to={PAGES.NEWPRODUCTS_CT}>
                        <span className="wes-new-product" /> New Products
                      </Link>
                    </li>
                    <li>
                      <Link to={PAGES.CLEARANCE_CT}>
                        <span className="wes-clearance" /> Clearance Products
                      </Link>
                    </li>
                    <li>
                      <Link to={PAGES.BRANDMODEL}>
                        <span className="wes-shop-brand" /> Compatible Brands
                      </Link>
                    </li>
                    <li>
                      <Link to={PAGES.ONLINE_CATALOGUE} data-guest-allow>
                        <span className="wes-catalogue" /> Catalogue eBook
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="quick-links">
                  <ul className="m-0 p-0 quick-menu quick-menu-effect">
                    {/* <li>
                      <Link to={PAGES.FAQ} data-guest-allow>
                        <i className="fa-regular fa-message" /> Help
                      </Link>
                    </li> */}
                    <li>
                      <Link to={PAGES.ABOUTUS} data-guest-allow>
                        <i className="fa-regular fa-message" /> About Us
                      </Link>
                    </li>
                    <li>
                      <Link to={PAGES.CONTACTUS} data-guest-allow>
                        <span className="wes-call" /> Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <QuickOrderMain />
    </>
  );
};
